import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value", "checked"]
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      block: "",
      type: "button",
      class: "my-5",
      onClick: _ctx.revertAllSelection
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectAllText[_ctx.selectAll]), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_v_row, { class: "mb-5" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: label,
            cols: "12",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                type: "checkbox",
                value: label,
                checked: _ctx.modelValue.get(label),
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSelected($event.target.value)))
              }, null, 40, _hoisted_1),
              label
                ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(label), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}